import anonymousImage from "../assets/images/boardOfDirectors/anonymousPerson.png";
import amrELAusary from "../assets/images/ourTeam/Amr El Arousy.png";
import amrZidanImage from "../assets/images/ourTeam/Amr Zidan.png";
const AssetManagment = [
  {
    image: amrELAusary,
    header: "Amr El Arousy",
    paragraph: "Chairman & CEO",
  },
  {
    image: amrZidanImage,
    header: "Amr Zidan",
    paragraph: "Managing Director",
  },
];

export default AssetManagment;
